import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useParams } from "react-router";

import { ProjectDetailViewContainer } from "../common/styled/project";

import Info from "./projectDetailView/info";
import Dashboard from "./projectDetailView/dashboard";
import Participants from "./projectDetailView/participants";
import Files from "./projectDetailView/files";
import TabMenu from "./projectDetailView/tabMenu";
import Scheduler from "./projectDetailView/scheduler";
import Calendar from "./projectDetailView/calendar";
import Event from "../../../scheduler/component/scheduler/event";
import History from "./projectDetailView/history";
import InviteModal from "./projectDetailView/modal/inviteModal";
import KickModal from "./projectDetailView/modal/kickModal";
import ChatModal from "./projectDetailView/modal/chatModal";

import { keysToRemove, transformEvents } from "../../../scheduler/component/function/common";
import { useModal } from "../../../../../hooks/useModal";

const ProjectDetailView = ({
  project,
  setProject,
  projectNotice,
  participantList,
  projectInfo,
  active,
  setActive,
  openMenu,
  setOpenMenu,
  getParticipantList,
  participant,
  projectRoomList,
  getProjectRoom,
  setShowSideMenu,
  events,
  schedule,
  getProjectSchedule,
}) => {
  const { projectNo } = useParams();

  const user = useSelector((state) => state?.user?.data[0]);
  const company = useSelector((state) => state?.company?.data);

  const { modal, openModal, closeModal } = useModal();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [showParticipants, setShowParticipants] = useState(false);
  const [eventInfo, setEventInfo] = useState(null);
  const [showEvent, setShowEvent] = useState(false);

  useEffect(() => {
    getEvents();
  }, [events]);

  // 이벤트 삭제
  const submitDelete = async (event) => {
    const url = "/api/schedule";
    const body = keysToRemove(event);

    body.delYn = "Y";
    body.createMberId = user.mberNo;

    try {
      const res = await axios.put(url, body);
      if (res.status === 200) {
        toast.success(`${event.dday === "Y" ? "디데이가" : "일정이"} 삭제되었습니다.`, {
          toastId: "no-access",
        });

        setEventInfo(null);
        setShowEvent(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getEvents = async () => {
    const { events: eventList } = await transformEvents(events, company);
    const transformEvent = eventList.map((item) => ({
      ...item,
      originTitle: item.title,
      title: item.certainType ? item.certainType : item.title,
    }));

    setData(transformEvent);
  };

  const changeModalState = (type = "") => {
    setIsModalOpen(type);
  };

  // 탭 메뉴 변경
  const tabChange = (idx) => setActive(idx);

  const componentList = useMemo(
    () => [
      <Dashboard
        project={project}
        projectNotice={projectNotice}
        projectInfo={projectInfo}
        projectRoomList={projectRoomList}
        participant={participant}
        changeModalState={changeModalState}
      />,
      <Calendar
        schedule={schedule}
        participant={participant}
        data={data}
        setEventInfo={setEventInfo}
        setShowEvent={setShowEvent}
        events={events}
      />,
      <Scheduler project={project} participantList={participantList} schedule={schedule} />,
      <Files project={project} />,
      null,
      <History />,
    ],
    [
      project,
      projectNotice,
      projectInfo,
      projectRoomList,
      participant,
      schedule,
      data,
      participantList,
      setEventInfo,
      setShowEvent,
    ],
  );

  const getModal = () => {
    switch (isModalOpen) {
      case "invite":
        return (
          <InviteModal
            changeModalState={changeModalState}
            project={project}
            participantList={participantList}
            getParticipantList={getParticipantList}
            getProjectRoom={getProjectRoom}
            participant={participant}
          />
        );
      case "kick":
        return (
          <KickModal
            project={project}
            participantList={participantList}
            getParticipantList={getParticipantList}
            changeModalState={changeModalState}
          />
        );
      case "chat":
        return (
          <ChatModal
            changeModalState={changeModalState}
            project={project}
            projectRoomList={projectRoomList}
            participantList={participantList}
            getProjectRoom={getProjectRoom}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      {modal}
      <ProjectDetailViewContainer>
        {showEvent && (
          <Event
            eventInfo={eventInfo}
            setEventInfo={setEventInfo}
            setShowEvent={setShowEvent}
            submitDelete={submitDelete}
            getSchedule={() => getProjectSchedule({ projectNo: projectNo })}
          />
        )}
        <Info
          project={project}
          setProject={setProject}
          openMenu={openMenu}
          setOpenMenu={setOpenMenu}
          projectInfo={projectInfo}
          setShowSideMenu={setShowSideMenu}
          setShowParticipants={setShowParticipants}
          participant={participant}
          openModal={openModal}
          closeModal={closeModal}
        />
        <div className="projectInfoBody">
          <div className="content">
            <TabMenu tabChange={tabChange} />
            {componentList[active]}
          </div>
          <Participants
            participantList={participantList}
            project={project}
            participant={participant}
            changeModalState={changeModalState}
            isInviteOpen={isModalOpen}
            showParticipants={showParticipants}
            setShowParticipants={setShowParticipants}
          />
          {isModalOpen && getModal()}
        </div>
      </ProjectDetailViewContainer>
    </>
  );
};

export default ProjectDetailView;
